import { lowercaseWords } from './constants';

export const formatNameString = (string) => {
  const lowercasedString = string.toLowerCase();
  const capitalizedFirstLetter =
    lowercasedString.charAt(0).toUpperCase() + lowercasedString.slice(1);
  const formattedString = capitalizedFirstLetter.replace(/(\s\w)/g, (match) =>
    match.toUpperCase()
  );
  return formattedString;
};

export const formatTravelNameString = (string) => {
  if (!string) return '';

  const words = string.toLowerCase().split(' ');

  return words
    .map((word, index) => {
      if (index === 0 || !lowercaseWords.includes(word)) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    })
    .join(' ');
};
